import { Box, Button } from '@mui/material';
import { useFormikContext } from 'formik';
import ProofOfPurchaseDetails  from './ProofOfPurchaseDetails';
import { Dispatch, SetStateAction, useLayoutEffect, useState } from 'react';
import './ProofOfPurchase.css';
import { isEqual as _isEqual } from 'lodash';

const isFormUnchanged = (formikValues: any, initialFormikValues: any) => {
    return _isEqual(formikValues, initialFormikValues);
};

interface mixCodesProps {
    handleTabChange: Dispatch<SetStateAction<boolean>>
}
const ProofOfPurchaseForm = ({handleTabChange}: mixCodesProps) => {
    const formik = useFormikContext();
    const [changesApplied, setChangesApplied] = useState(false);

    useLayoutEffect(() => {
        const hasChanges = !isFormUnchanged(formik.values, formik.initialValues);
        const showModal = hasChanges && (formik.submitCount === 0 || (formik.submitCount > 0 && !formik.isValid));
        setChangesApplied(hasChanges);
        handleTabChange(showModal);
    }, [formik.values, formik.initialValues, formik.submitCount, formik.isValid, handleTabChange]);

    return (
        <>
            <ProofOfPurchaseDetails formik={formik}/>
            <Box className='proof-of-purchase-form-buttons'>
                {changesApplied && <Button variant='outlined' onClick={() => formik.resetForm({ values: formik.initialValues })}>Discard</Button>}
                <Button variant="contained" color="primary" type="submit" data-testid="mix-code-save-button">Save</Button>
            </Box>
        </>
    )
}

export { ProofOfPurchaseForm }
